import { render } from "./ElementoForm.vue?vue&type=template&id=f68a675e"
import script from "./ElementoForm.vue?vue&type=script&lang=js"
export * from "./ElementoForm.vue?vue&type=script&lang=js"

import "./ElementoForm.vue?vue&type=style&index=0&id=f68a675e&lang=scss"
script.render = render

export default script